<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">网 址：</span>
                <a-input placeholder="" class="seachs" v-model="seach.domain"/>
            </div>
            <div class="seachList"><span class="name">提交日期：</span>
                <a-range-picker class="seachs" v-model="seach.create_time" :allowClear="false" :showTime="false"  format="YYYY-MM-DD"/>
            </div>
            <div class="seachList" style="">
                <a-button type="primary" class="seachBtn" @click="getList(1)" style="margin-right: 10px"> 搜索</a-button>
                <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  >
            <p slot="company" slot-scope="text, record">
                <span style="display: inline-block ;"> 
                    <a-tooltip placement="left" :title="record.erp_remark" 
                        :get-popup-container="getPopupContainer" 
                        v-if='record.erp_remark'> 
                        <a-icon type="container"  style="cursor: pointer"/> 
                    </a-tooltip>
                </span> 
                {{text}} 
            </p>
            <span slot="action" slot-scope="text, record"> <a @click="details(text.id )">查看</a></span>
        </a-table>
    </div>
</template>
<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById} from "../../utils/utils"
    const columns = [
        {
            title: "客户名称",
            dataIndex: "company",
            width: "300px",
            ellipsis: true,
            scopedSlots: {customRender: "company"},
            key: "company"
        },
        {
            title: "网址",
            dataIndex: "domain",
            width: "300px",
            ellipsis: true,
            key: "domain"
        },
        {
            title: "提交日期",
            dataIndex: "create_date",
            width: "200px",
            ellipsis: true,
            key: "create_date"
        },
        {
            title: "内容",
            dataIndex: "content",
            width: "300px",
            ellipsis: true,
            key: "content"
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "FeedBack",
        data() {
            return {
                selectedRowKeys: [],
                resetSeachdata:true,
                page:1,
                seach: {
                    domain: "",
                    create_time:""
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/FeedBack"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        computed: {
        },
        components: {},
        methods: {
            resetSeach() {
                this.loading = true
                this.seach = {
                    domain: "",
                    create_time:[],
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                this.selectedRowKeys=[]
                this.page=page
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.create_time.length > 0&&this.resetSeachdata==true) {
                    seachData.create_time[0] = moment(this.seach.create_time[0]).format('YYYY-MM-DD')
                    seachData.create_time[1] = moment(this.seach.create_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.create_time=[]
                }
                API.feedback.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.info.data
                    if(!this.resetSeachdata==true){
                        this.seach.online_time=[]
                        this.seach.expire_time=[]
                    }
                    this.resetSeachdata=true
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            details(id){
                this.$router.push({path: '/CustomerManagement/FeedBackDetails', query: {id:id}})
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name { width: 70px !important;}
    .seachBox .seachBtnBox .seachBtn{margin-top: 0!important;}
    .seachBox .seachList .seachs.white >>> .ant-input{color: #fff!important;}
    .seachBox .seachList .seachs.white >>> .ant-calendar-range-picker-separator{color: #fff!important;}
    .seachBox .seachList .seachs.white >>> .ant-calendar-picker{color: #fff!important;}
</style>
